import { render, staticRenderFns } from "./fwxz.vue?vue&type=template&id=07119874&scoped=true&"
import script from "./fwxz.vue?vue&type=script&lang=js&"
export * from "./fwxz.vue?vue&type=script&lang=js&"
import style0 from "./fwxz.vue?vue&type=style&index=0&id=07119874&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07119874",
  null
  
)

export default component.exports